import React from "react";
import { Label, Alert, Select, Hint } from "@americanexpress/dls-react";

/**
 * SelectField is a reusable dropdown component using @americanexpress/dls-react Select.
 *
 * Props:
 * - id: string - The unique identifier for the select element.
 * - label: string - The label displayed above the select.
 * - value: any - The currently selected value.
 * - options: array - The list of options to display in the dropdown.
 * - onChange: function - Callback when the selected value changes.
 * - error: string (optional) - Error message to display below the select.
 * - fluid: boolean (optional) - Stretch the select to the column width (default: true).
 * - ...rest: any - Additional props passed to the Select component.
 */
const SelectField = ({ id, label, value, options, onChange, error, colmd = 'col-md-4', hint, fluid = true, ...rest }) => (
     <div className={`${colmd} col-xs-12 pad-2-b`}>
    {label && <Label htmlFor={id}>{label}</Label>}
    <Select
      id={id}
      options={options}
      fluid={fluid}
      value={value}
      onChange={onChange}
      {...rest}
    />
    {hint && <Hint>{hint}</Hint>}
    {error && <Alert status="error">{error}</Alert>}
  </div>
);

export default SelectField;
